import React, { FC } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FindingTypeProperty, CreateFindingTypeRuleWithIndex } from '../AnnotationStandardForm.slice';
import { Select, Input, Tooltip } from 'antd';
import styles from './Rules.module.scss';
import classNames from 'classnames';
import { motion } from 'framer-motion';
import { shake } from '../../../Shared/Motion';
const { Option } = Select;

type Props = {
  findingTypeId: string;
  rule: CreateFindingTypeRuleWithIndex;
  properties: Array<FindingTypeProperty>;
  canEdit: boolean;
  removeClicked: (index: number, findingTypeId: string) => void;
  onHandleChange: (index: number, findingTypeId: string, findingTypePropertyId: string, value: string) => void;
};

const FindingTypeRuleRow: FC<Props> = ({ findingTypeId, rule, properties, removeClicked, canEdit, onHandleChange }) => {
  const handleChange = (value: string, propertyId: string) => {
    onHandleChange(rule.index, findingTypeId, propertyId, value.toString());
  };

  const generateInput = (property: FindingTypeProperty) => {
    if (property.values && property.values.length) {
      return (
        <td style={{ textAlign: 'center' }} key={property.id}>
          <Select
            disabled={!canEdit}
            style={{ width: 120 }}
            onChange={(e: any) => handleChange(e, property.id)}
            value={
              rule.items && rule.items.find(x => x.findingTypePropertyId === property.id)
                ? rule.items.find(x => x.findingTypePropertyId === property.id)!.value
                : ''
            }
          >
            {property.values &&
              property.values
                .split(',')
                .map(x => x.trim())
                .map(value => (
                  <Option key={value} value={value}>
                    <Tooltip key={value} title={value}>
                     <span>{value}</span>
                  </Tooltip>
                  </Option>
                ))}
          </Select>
        </td>
      );
    } else {
      return (
        <td style={{ textAlign: 'center' }} key={property.id}>
          <Input
            disabled={!canEdit}
            style={{ width: 120 }}
            onChange={e => handleChange(e.target.value, property.id)}
            value={
              rule.items && rule.items.find(x => x.findingTypePropertyId === property.id)
                ? rule.items.find(x => x.findingTypePropertyId === property.id)!.value
                : ''
            }
          />
        </td>
      );
    }
  };

  return (
    <>
      {properties.some(x => x.values !== '') && (
        <motion.tr variants={shake} animate={rule.errorMark ? 'invalid' : 'valid'}>
          {properties.map(property => generateInput(property))}
          <td style={{ width: '20px' }}>
            <FontAwesomeIcon
              icon={faTimes}
              onClick={e => canEdit && removeClicked(rule.index, rule.findingTypeTemplateId)}
              className={classNames(styles.remove, {
                [styles.disabled]: !canEdit
              })}
            />
          </td>
        </motion.tr>
      )}
    </>
  );
};

export default FindingTypeRuleRow;
